import { MobXProviderContext } from 'mobx-react'
import React from 'react'

const useStores = () => {
  return React.useContext(MobXProviderContext)
}

export default useStores
